export default "__VITE_ASSET__DTN_APy3__"